import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt } from "lucide-react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const PAY_STATUS = {
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800" },
  created: { label: "Pending", cls: "bg-amber-100 text-amber-800" },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-800" },
  failed: { label: "Failed", cls: "bg-rose-100 text-rose-700" },
};

export function PayBadge({ status }) {
  const s = PAY_STATUS[status] || { label: status, cls: "bg-secondary" };
  return <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase ${s.cls}`}>{s.label}</span>;
}

export function PaymentHistory() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/me/payments").then((r) => setRows(r.data)); }, []);
  return (
    <>
      <h2 className="mt-10 font-display text-xl font-bold">Payment history</h2>
      {rows.length === 0 ? (
        <Card className="mt-3 border-dashed"><CardContent className="p-6 text-sm text-muted-foreground" data-testid="payment-history-empty">No payments yet.</CardContent></Card>
      ) : (
        <Card className="mt-3 border-border/70" data-testid="payment-history">
          <CardContent className="overflow-x-auto p-0">
            <Table>
              <TableHeader><TableRow>
                <TableHead>Date</TableHead><TableHead>Course</TableHead><TableHead className="text-right">Amount</TableHead><TableHead>Status</TableHead><TableHead />
              </TableRow></TableHeader>
              <TableBody>
                {rows.map((p) => (
                  <TableRow key={p.id} data-testid={`my-payment-${p.id}`}>
                    <TableCell className="text-xs">{new Date(p.paid_at || p.created_at).toLocaleString("en-IN")}</TableCell>
                    <TableCell className="text-sm">{p.course_name}</TableCell>
                    <TableCell className="text-right font-mono text-xs">₹{p.amount.toLocaleString("en-IN")}</TableCell>
                    <TableCell><PayBadge status={p.status} /></TableCell>
                    <TableCell className="text-right">
                      {p.status === "paid" && (
                        <Button asChild size="sm" variant="outline" data-testid={`receipt-link-${p.id}`}><Link to={`/receipt/${p.id}`}><Receipt className="mr-1 h-3.5 w-3.5" /> Receipt</Link></Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </>
  );
}
